import React, { useState } from 'react';
import axios from 'axios';
import { Alert,Container, FormText, Col, Form, Row, FormGroup, Label, Input, Button } from 'reactstrap';
import AuthorizeRoute from './api-authorization/AuthorizeRoute';
import ApiAuthorizationRoutes from './api-authorization/ApiAuthorizationRoutes';
import { ApplicationPaths } from './api-authorization/ApiAuthorizationConstants';
import authService from './api-authorization/AuthorizeService';
import { FaDownload } from 'react-icons/fa'; 

class VerDocumentos extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            Id: 0,
            UserId: '',
            ApellidoP: '',
            ApellidoM: '',
            Nombres: '',
            Genero: '',
            lugar_Nacimiento: '',
            Nacionalidad: '',
            Pais_Nacimiento: '',
            RFC_Homoclave: '',
            CURP: '',
            Fecha_Nacimiento: '',
            Num_ident_Oficial_Vigente: '',
            Tipo: '',
            Correo: '',
            hideOtroDestinodelCredito: true,



            AddressDetail: '',
            CologneFractionation: '',
            PostalCode: 0,
            DelegationMunicipality: '',
            State: '',
            Telf_Particular: '',
            Telf_Particular2: '',
            Cellphone: '',
            Telf_Celular2: '',



            MaximumDegreeStudies: '',
            MaritalStatus: '',
            SpousalRegime: '',
            NumEconomicDependents: 0,
            FullNameSpouse: '',
            OccupationSpouse: '',
            BusinessSpouse: '',
            CellphoneSpouse: '',
            CompanyPhoneSpouse: '',
            TypeHousing: '',
            Otro: '',
            YearsResidence: 0,
            Empleador: '',
            TipodeEmpleo: '',
            IngresosDeclaradosMensuales: 0,
            FechaIngreso: '',
            MontoSolicitado: 0,
            NumeroParcialidades: 0,
            MontoPosibleApagar: 0,
            UsoCredito: '',
            DestinodelCredito: '',
            OtroDestinodelCredito: '',
            NombreCompleto1: '',
            Parentesco1: '',
            TelfLd1: '',
            Telefono1: '',
            TelfExt1: '',
            NombreCompleto2: '',
            Parentesco2: '',
            TelfLd2: '',
            Telefono2: '',
            TelfExt2: '',
            NombreCompleto3: '',
            Parentesco3: '',
            TelfLd3: '',
            Telefono3: '',
            TelfExt3: '',
            Estado: '',
            FechaModificacion: '',
            Firma: '',
            UserIdLogin: '',
            aceptarCondiciones: false,
            Rol: '',
            Comentario: '',
            EstadoModal: '',
            errors: {},
            sigPad: {
                width: 500,
                height: 200,
            },

            trimmedDataURL: null,
            imageFirma: null,
            imagenselfie: false,
          

        }
        
    }
    componentDidMount() {
     //   console.log("acaaaas")

      

        this._subscription = authService.subscribe(() => this.populateState2());
        this.populateState2();
      
        //var validador = window.checkParameters()


        axios.get('GetSaS')
            .then(response => {

                var azure = response.data.split('@')
                window.sas = azure[0];
                window.account = azure[1];
                var validador = window.checkParameters()
                if (validador == true) {
                    window.getBlobService()
                    window.viewContainer(azure[2])
                }
            })
            .catch(function (error) {
                console.log(error);
            })

        //if (validador == true) {
        //    window.getBlobService()
        //    window.viewContainer('maxcapitalmexdocs')


        //}





    }
    async populateState2() {
        const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
        
        this.setState({ UserIdLogin: user.sub })


        this.GetUserCurrent();
       

        //  window.refreshBlobList(this.state.UserId)
    }

   
    cancelarPantalla = () => {
        window.history.back();
    }
    GetUserCurrent = () => {
       // console.log(this.props.match.params.id)
        axios.get('/Api/Usuario/UsuarioRole?idEmpleado=' + this.state.UserIdLogin)

            .then(response => {
               // console.log(response);
               // console.log(response.data);
                if (response.data.length > 0) {
                    this.setState({
                        Rol: response.data[0].role
                    })
                    this.getInfo()
                } else {
                    alert("No tiene los permisos para ingresar a página")
                    this.props.history.push('/')
                }

                
            })
            .catch(function (error) {
                console.log(error);
            })
        //
    }

    getInfo = () => {
        axios.get('/Api/Credito/CreditodetailById?id=' + this.props.match.params.id)
            .then(response => {
             //   console.log(response.data);
              //  console.log(this.state)
                this.setState({
                    Id: this.props.match.params.id,
                    ApellidoP: response.data[0].lastName,
                    Nombres: response.data[0].name,
                    ApellidoM: response.data[0].secondLastName,
                    Genero: response.data[0].gender,
                    lugar_Nacimiento: response.data[0].cityofBirth,
                    Nacionalidad: response.data[0].nationality,
                    Pais_Nacimiento: response.data[0].countryofBirth,
                    RFC_Homoclave: response.data[0].rfc,
                    CURP: response.data[0].curp,
                    Fecha_Nacimiento: response.data[0].dob,
                    Num_ident_Oficial_Vigente: response.data[0].officialIdNumber,
                    Tipo: response.data[0].officialIdType,
                    Correo: response.data[0].email,
                    Telf_Particular: response.data[0].phoneNumber,
                    NumeroParcialidades: response.data[0].numeroParcialidades.toString(),
                    MontoPosibleApagar: response.data[0].montoPosibleApagar.toString(),
                    UsoCredito: response.data[0].usoCredito,
                    DestinodelCredito: response.data[0].destinodelCredito,
                    OtroDestinodelCredito: response.data[0].otroDestinodelCredito,
                    Empleador: response.data[0].empleador,
                    TipodeEmpleo: response.data[0].tipodeEmpleo,
                    IngresosDeclaradosMensuales: response.data[0].ingresosDeclaradosMensuales.toString(),
                    FechaIngreso: response.data[0].fechaIngreso,
                    IdSolicitud: response.data[0].IdSolicitud,
                    NombreCompleto1: response.data[0].nombreCompleto1,
                    Parentesco1: response.data[0].parentesco1,
                    TelfLd1: response.data[0].telfLd1,
                    Telefono1: response.data[0].telefono1,
                    TelfExt1: response.data[0].telfExt1,
                    NombreCompleto2: response.data[0].nombreCompleto2,
                    Parentesco2: response.data[0].parentesco2,
                    TelfLd2: response.data[0].telfLd2,
                    Telefono2: response.data[0].telefono2,
                    TelfExt2: response.data[0].telfExt2,
                    NombreCompleto3: response.data[0].nombreCompleto3,
                    Parentesco3: response.data[0].parentesco3,
                    TelfLd3: response.data[0].telfLd3,
                    Telefono3: response.data[0].telefono3,
                    TelfExt3: response.data[0].telfExt3,
                    AddressDetail: response.data[0].addressDetail,
                    CologneFractionation: response.data[0].cologneFractionation,
                    PostalCode: response.data[0].postalCode,
                    DelegationMunicipality: response.data[0].delegationMunicipality,
                    State: response.data[0].state,
                    Cellphone: response.data[0].cellphone,
                    TypeHousing: response.data[0].typeHousing,
                    YearsResidence: response.data[0].yearsResidence,
                    MaximumDegreeStudies: response.data[0].maximumDegreeStudies,
                    MaritalStatus: response.data[0].maritalStatus,
                    SpousalRegime: response.data[0].spousalRegime,
                    NumEconomicDependents: response.data[0].numEconomicDependents,
                    FullNameSpouse: response.data[0].fullNameSpouse,
                    OccupationSpouse: response.data[0].occupationSpouse,
                    BusinessSpouse: response.data[0].businessSpouse,
                    CellphoneSpouse: response.data[0].cellphoneSpouse,
                    CompanyPhoneSpouse: response.data[0].companyPhoneSpouse,
                    Estado: response.data[0].estadoCredito,
                    UserId: response.data[0].idUser
                })

               
                window.refreshBlobListAllDocumentos(this.state.UserId, this.state.Id, 0);
               
            })
            .catch(function (error) {
                console.log(error);
            })


    }
    Getzip = () => {
        window.refreshBlobListzip(this.state.UserId, this.state.Id, 0);
    }
    render() {
        return (
            <Container className="App">


                <h2 className="PageHeading" >DOCUMENTOS</h2>

                
                <hr />


                <Form className="form">
                    
                    <Col>
                        
                       
                        <Row className="rowGris">
                            <Col sm={6}>
                                <FormGroup>
                                    <Col sm={12}>
                                    <h5>Descargar todos los archivos de la solicitud</h5>
                                        <Button className="btn btn-success" onClick={this.Getzip} title="Descargar .zip"><FaDownload /></Button>
                                        <Alert color="success" id="ZipButton" className="alertHide">
                                            This is a success alert — check it out!
                                         </Alert>
                                        <Alert color="danger" id="ZipButtonFail" className="alertHide">
                                            This is a danger alert — check it out!
                                           </Alert>
                                        <hr />
                                    </Col>
                                        <Col sm={12}>
                                    <div id="result0"></div>
                                    </Col>
                                </FormGroup></Col>
                           

                        </Row>

                        
                        
                     
                    </Col>


                </Form>
            </Container>
        );
    }
}
export default VerDocumentos;

